module.exports = __webpack_public_path__ + "static/img/MM.080e7a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/MM.jpg
// module id = msFD
// module chunks = 51